import { ICrudLocale } from '@app/i18n/interface';

export const PROVIDER_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  PROVIDER: {
    LABEL: {
      SINGULAR: 'Provider',
      PLURAL: 'Providers',
    },
    FORM: {
      EDIT_DESCRIPTION:
        "Update the selected provider's operational configuration.",
      FETCH_ERROR: 'Sorry, an error occurred while fetching the provider.',
    },
    FIELD: {
      CODE: 'Code',
      NAME: 'Name',
      ENVIRONMENT: 'Environment',
      TIMEOUT_MS: 'Timeout (ms)',
      TIMEOUT_MS_HINT:
        'Per-request timeout override, between {{ min }} and {{ max }} ms. Leave empty to use the default.',
      LABELS: 'Labels',
      LABELS_HINT: 'Free operational labels separated by commas.',
      CREDENTIALS: 'Credentials configured',
      ENABLED: 'Enabled',
    },
    ENVIRONMENT: {
      PROD: 'Production',
      TEST: 'Test',
    },
    CREDENTIALS: {
      YES: 'Yes',
      NO: 'No',
    },
    LIST: {
      TITLE: 'Providers list',
    },
  },
};
